import { render, staticRenderFns } from "./ProfessorVinculoCard.vue?vue&type=template&id=ab701bf6&scoped=true"
import script from "./ProfessorVinculoCard.vue?vue&type=script&lang=js"
export * from "./ProfessorVinculoCard.vue?vue&type=script&lang=js"
import style0 from "./ProfessorVinculoCard.vue?vue&type=style&index=0&id=ab701bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab701bf6",
  null
  
)

export default component.exports